<template>
  <div :class="['definition-wrapper', 'dateInterval', definition.id, {'error_validate': mandatoryValidation || validation}]">
    <div v-if="editable">
      <date-picker range
        v-model:value="dateIntervalValue"
        :lang="lang"
        :format="format"
        :first-day-of-week="firstDayOfWeek"
        :confirm="confirm"
        :shortcuts="shortcuts.length ? shortcuts : null"
        :editable="isManualEditable"
        :input-name="definition.id"
        :show-week-number="false"
        @change="valueChanged($event)"
      />
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :visualDefinition="visualDefinition" />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DatePicker from 'vue-datepicker-next'
import moment from 'moment'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../language'

export default {
  name: 'definition-date-interval',
  components: {
    DefinitionReadOnly,
    DatePicker
  },
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'placeholder',
    'callTask'
  ],
  data () {
    return {
      dateIntervalValue: [],
      format: this.getFormat(),
      firstDayOfWeek: 1,
      confirm: false,
      shortcuts: [],
      isManualEditable: false,
      validation: null
    }
  },
  beforeMount () {
    this.dateIntervalValue = this.getDateIntervalValue()
  },
  methods: {
    // 1. Launch validate mandatory event on date change
    valueChanged (event) {
      this.setDateIntervalValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    validateDateIntervalFormat () {
      var value = this.getDateIntervalValue()
      if (value && value.length > 0) {
        // 3. if date format validation past...
        var errorFound = false
        for (var j = 0; j < value.length && !errorFound; j++) {
          if (value[j]) {
            this.validation = transport.methods.validateDateFormat(this.definition, value[j])
            if (this.validation) {
              errorFound = true
            }
          }
        }
        if (!errorFound) {
          // ... and launch refresh definition event
          this.$emit('refreshDefinition', this.object)
        } else {
          // ... or launch date interval format error event to show error message
          this.$emit('dateIntervalFormatError', moment().valueOf(), this.validation, this.definition.validation.format)
        }
      } else {
        this.$emit('refreshDefinition', this.object)
      }
    },
    getDateIntervalValue () {
      var result = []
      if (this.object.textValue && this.object.textValue !== '') {
        var myRegexp = /\[([^\]]+)\]/g
        var match = myRegexp.exec(this.object.textValue)
        while (match) {
          var date = transport.methods.getDate(match[1], this.definition)
          result.push(date)
          match = myRegexp.exec(this.object.textValue)
        }
      }
      return result
    },
    setDateIntervalValue () {
      var value = this.dateIntervalValue
      this.object.textValue = null
      if (value && value.length > 0) {
        var errorFound = false
        for (var j = 0; j < value.length && !errorFound; j++) {
          if (value[j]) {
            this.validation = transport.methods.validateDateFormat(this.definition, value[j])
            if (!this.validation) {
              // ... set date interval value
              var objDateIntervalValue = `[${transport.methods.getDateStr(value[j], this.definition)}]`
              if (!this.object.textValue) {
                this.object.textValue = objDateIntervalValue
              } else {
                this.object.textValue += objDateIntervalValue
              }
            } else {
              errorFound = true
            }
          }
        }
        if (errorFound) {
          this.object.textValue = null
        }
      }
    },
    getFormat () {
      return transport.methods.getDateFormat(this.definition.validation.format.regExp)
    }
  },
  computed: {
    lang () {
      var result = language(this.language, 'datepicker')
      if (result instanceof Object && this.placeholder) {
        result.placeholder.dateRange = this.placeholder
      }
      return result
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (!value.validateKey || value.validateKey.trim() === '')) {
        // ... launch date interval format validation
        this.validateDateIntervalFormat()
      }
    },
    object (value) {
      this.dateIntervalValue = this.getDateIntervalValue(value)
    }
  }
}
</script>

<style lang="scss">
.mx-datepicker-range {
  width: 100% !important;
}
.mx-input {
  box-shadow: none;
  border: 1px solid #e8e8e8;
  min-height: 33px;
  font-size: 14px;
  font-family: 'Noto Sans';
  height: 33px;
  padding: 5px 30px 3px 10px;
  color: #333;
  border-radius: 2px;

  &::placeholder {
    color: #adadad;
    font-style: italic;
  }
}
</style>
